// extracted by mini-css-extract-plugin
module.exports = {"graphMetric":"BenchmarkMetrics_graphMetric__Pg6uz"};